import { Box, Divider, Typography } from "@mui/material";
import React from "react";

export interface FieldSectionProps {
  label: string;
  children: React.ReactNode;
  flexType?: string;
  description?: string;
  divider?: boolean;
}

const FieldSection = ({
  label,
  children,
  flexType = "flex",
  description,
  divider = true,
}: FieldSectionProps) => {
  return (
    <>
      <Box display={flexType} mb={3} mt={3}>
        <Box flex={4}>
          <Typography
            fontFamily="Inter"
            fontSize={16}
            fontWeight="600"
            color="rgba(65, 70, 81, 1)"
          >
            {label}
          </Typography>
          <Typography
            fontFamily="Inter"
            fontSize={14}
            color="#535862"
            sx={{
              display: "block",
              textIndent: "-1em",
              paddingLeft: "1em",
              whiteSpace: "pre-line",
            }}
          >
            {description}
          </Typography>
        </Box>
        <Box flex={8}>{children}</Box>
      </Box>
      {divider && <Divider component="div" flexItem sx={{ width: "100%" }} />}
    </>
  );
};

export default FieldSection;
